export const SEMESTER = "2023-2";
